import React from 'react';
import { FlowNode } from '../../../../types/flowBuilder';
import { BaseConfigProps, ConfigSection, ConfigField } from '../shared/ConfigFormHelpers';

interface CounterConfigProps extends BaseConfigProps {
  node: FlowNode;
  updateConfig: (key: string, value: any) => void;
}

const CounterConfig: React.FC<CounterConfigProps> = ({ node, updateConfig }) => {
  return (
    <div className="space-y-4">
      <ConfigSection title="Számláló beállítások">
        <ConfigField
          label="Számláló neve"
          description="Egyedi azonosító a számlálónak"
        >
          <input
            type="text"
            value={node.data.config?.counterName || 'counter'}
            onChange={(e) => updateConfig('counterName', e.target.value)}
            placeholder="my_counter"
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          />
        </ConfigField>

        <ConfigField
          label="Kezdőérték"
          description="A számláló kezdeti értéke"
        >
          <input
            type="number"
            value={node.data.config?.initialValue || 0}
            onChange={(e) => updateConfig('initialValue', parseInt(e.target.value))}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          />
        </ConfigField>

        <ConfigField
          label="Növekmény"
          description="Mennyivel növekedjen minden futáskor"
        >
          <input
            type="number"
            value={node.data.config?.increment || 1}
            onChange={(e) => updateConfig('increment', parseInt(e.target.value))}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          />
        </ConfigField>

        <ConfigField
          label="Maximum érték"
          description="Opcionális felső határ (0 = nincs limit)"
        >
          <input
            type="number"
            value={node.data.config?.maxValue || 0}
            onChange={(e) => updateConfig('maxValue', parseInt(e.target.value))}
            min="0"
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          />
        </ConfigField>

        <div className="flex items-center">
          <input
            type="checkbox"
            id="resetOnMax"
            checked={node.data.config?.resetOnMax || false}
            onChange={(e) => updateConfig('resetOnMax', e.target.checked)}
            className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
          />
          <label htmlFor="resetOnMax" className="ml-2 text-sm text-gray-700 dark:text-gray-300">
            Nullázás maximum elérésekor
          </label>
        </div>
      </ConfigSection>

      <div className="bg-purple-50 dark:bg-purple-900/20 border border-purple-200 dark:border-purple-800 rounded-md p-3">
        <div className="text-xs text-purple-700 dark:text-purple-300">
          <strong>🔢 Számláló használat:</strong>
          <br />• Automatikus sorszámozás
          <br />• Iterációk számolása
          <br />• Eredmény: <code>{'{{count}}'}</code>
          <br />• Minden futáskor növekszik
        </div>
      </div>
    </div>
  );
};

export default CounterConfig;
